import { AppliedGiftCard } from 'components/AppliedGiftCard/AppliedGiftCard';
import { FC } from 'react';
import { useGiftCard } from 'routes/Checkout/context/GiftCard/GiftCardContext';
import { useInvoiceSummary } from 'routes/Checkout/context/InvoiceSummary';
import styles from './GiftCardList.module.scss';

export const formatBalance = (balance: number) => {
  let balanceAsString = balance.toString();
  if (balanceAsString.includes('.')) {
      const decimalPart = balanceAsString.split('.')[1];
      if (decimalPart.length === 1) {
          balanceAsString += '0';
      }
  }

  return balanceAsString;
};
export const GiftCardList: FC = () => {
  const { unSetGiftCard } = useGiftCard();
  const { invoiceSummary } = useInvoiceSummary();
  const handleGiftCardRemoval = (token: string) => {
    unSetGiftCard(token);
  };
  if (!invoiceSummary?.giftSources || invoiceSummary?.giftSources.length === 0) {
    return null;
  }

  return (
    <div data-testid="giftCardList" className={styles.giftCardList}>
      {invoiceSummary?.giftSources?.map((card) => (
        <AppliedGiftCard
          key={card.token}
          last4={card.last4}
          token={card.token}
          balance={card.balance ? formatBalance(+card.balance / 100) : '0'}
          handleGiftCardRemoval={handleGiftCardRemoval}
        />
      ))}
    </div>
  );
};
